import { Component, ViewChild, ElementRef } from '@angular/core';
import { NavController, NavParams, ModalController } from 'ionic-angular';

import { ContratosGestaoService } from '../../../../../providers/contratos-gestao-service';
import { AlertService } from '../../../../../providers/alert-service';
import { MenuService } from '../../../../../providers/menu-service';
import { ModulosController } from '../../../modulos-controller';
import { UsuarioService } from '../../../../../providers/usuario-service';
import { GestaoPcaService } from '../../../../../providers/gestao-pca-service';

import { ModalPessoaRolPage } from '../../../../modais/modal-pessoa-rol/modal-pessoa-rol';

@Component({
    selector: 'page-verificacao-rol',
    templateUrl: 'verificacao-rol.html',
    providers: [
        ContratosGestaoService
    ]
})

export class VerificacaoRolPage extends ModulosController {
    @ViewChild('myInput') myInput: ElementRef;

    cpfMask = [/\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/];
    listaDados: any = [];
    listaTipoResp: any = [];
    tipoRespSelecionada: any;
    loading: boolean = true;
    submetendoNoCertificado: boolean = false;
    idSecaoPagina: string = "150";

    page: number = 1;

    order: string = 'numeroContrato';
    reverse: boolean = true;

    constructor(public navCtrl: NavController,
        public alertService: AlertService,
        public modalCtrl: ModalController,
        public usuarioService: UsuarioService,
        public navParams: NavParams,
        public contratosGestaoService: ContratosGestaoService,
        public gestaoPcaService: GestaoPcaService,
        private menuService: MenuService) {
        super(modalCtrl, navParams, alertService, usuarioService, gestaoPcaService);
        this.carregarDados();
        this.carregarTiposResponsavel();
        this.setModuloId(14);
    }

    setOrder(value: string) {
        if (this.order === value) {
            this.reverse = false;
            this.order = "-" + value;
        } else {
            this.reverse = true;
            this.order = value;
        }
    }

    visualizar(dados) {
        let titulo = "Dados do Responsável";
        console.log(dados);
        let modal = this.modalCtrl.create(ModalPessoaRolPage,
            {
                param1: titulo,
                dados: dados
            });
        modal.onDidDismiss(retornoModal => {
            if (retornoModal && retornoModal.flag) {
                 this.carregarDados();
            }
        });
        modal.present();
    }

    carregarDados() {
        this.contratosGestaoService.listarVerificacaoRol().subscribe(data => {
            this.listaDados = data;
            this.loading = false;
        }, error => {
            console.log("erro: " + error);
            this.loading = false;
        });
    }

    onTipoResponsavelAlterada(dados) {
        this.tipoRespSelecionada = dados.tipoResponsavel.idTipo != undefined &&
                dados.tipoResponsavel.idTipo > 0;
      }

    carregarTiposResponsavel() {
        this.contratosGestaoService.listarTipoResponsaveis().subscribe(data => {
            this.listaTipoResp = data;
        }, error => {
            console.log("erro: " + error);
            this.loading = false;
        });
    }

    formatarValorNumerico(valor) {
        let valorFormatado = new Intl.NumberFormat('pt-BR',
            {
                style: 'currency',
                currency: 'BRL'
            }).format(valor);

        return valorFormatado.substr(2, valorFormatado.length).replace('$', '-');
    }

    voltarParaContratosGestao() {
        this.menuService.redirecionarPagina(this.contratosGestaoService.obterIdPaginaContratosGestao());
    }

    salvarFlagIncluir(enviarMensagem = true) {
        this.loading = true;
        this.listaDados.dsResultadoAnalise = this.capitalize(this.listaDados.dsResultadoAnalise);
        this.contratosGestaoService.salvarVerificacaoRol(this.listaDados).subscribe(data => {
            if (enviarMensagem) {
                this.alertService.mostraAlerta("", "Salvo com sucesso.");
                this.loading = false;
            }
        }, error => {
            this.alertService.mostraAlerta("", "Ocorreu um erro ao salvar:" + error);
            this.loading = false;
        })
    }

    cpf_mask(v) {
        v = v.replace(/\D/g, ''); //Remove tudo o que não é dígito
        v = v.replace(/(\d{3})(\d)/, '$1.$2'); //Coloca um ponto entre o terceiro e o quarto dígitos
        v = v.replace(/(\d{3})(\d)/, '$1.$2'); //Coloca um ponto entre o terceiro e o quarto dígitos
        //de novo (para o segundo bloco de números)
        v = v.replace(/(\d{3})(\d{1,2})$/, '$1-$2'); //Coloca um hífen entre o terceiro e o quarto dígitos
        return v;
      }

    submeterNoCertificado() {
        this.loading = true;
        if (this.listaDados.dsResultadoAnalise.replace(/^\s+|\s+$/g, '') == "" || this.listaDados.dsResultadoAnalise == null || this.listaDados.dsResultadoAnalise == undefined || !this.listaDados.dsResultadoAnalise) {
            this.alertService.mostraAlerta("", "O Parecer do Analista é obrigatório.");
            this.loading = false;
        } else {
            if (this.listaDados) {
                this.listaDados.dsResultadoAnalise = this.capitalize(this.listaDados.dsResultadoAnalise);
                this.contratosGestaoService.finalizarVerificacaoRol(this.listaDados).subscribe(data => {
                    this.alertService.mostraAlerta("", "Submetido com sucesso.");
                    this.voltarParaContratosGestao();
                }, error => {
                    this.alertService.mostraAlerta("", "Ocorreu um erro ao submeter:" + error);
                    this.loading = false;
                });
            }
        }
    }

    truncateText(text) {
        let numberOfWordsToTruncate = 10;

        if (text != undefined) {
            let separatedByWords = text.split(" ");

            if (this.needTruncate(text)) {
                return separatedByWords.slice(0, numberOfWordsToTruncate).join(" ") + " ...";
            }
            else {
                return text;
            }
        }
    }

    needTruncate(text) {
        let separatedByWords = text.split(" ");
        let numberOfWordsToTruncate = 10;

        return separatedByWords.length >= numberOfWordsToTruncate;
    }

    exibirCompleto(text) {
        this.alertService.mostraAlerta('', text);
    }

    formatarZeroEsquerda(valor) {
        return valor.replace(/^0+(?!\.|$)/, '');
    }

    capitalize(str) {
        let retorno = "";

        if (str) {
            retorno = str.charAt(0).toUpperCase() + str.slice(1);
        }

        return retorno;
    }
}



// WEBPACK FOOTER //
// ./src/pages/modulos/contratos-gestao/analista/verificacao-rol/verificacao-rol.ts